import { gql } from '@apollo/client'

export const chineseSurnames = gql`
  query Surnames {
    surnames {
      id
      romanizations(schemes: ["jyutping", "pinyin", "wade_giles"]) {
        scheme
        value
      }
      surname
    }
  }
`

export const getLifeEvents = gql`
  query GetLifeEvents {
    lifeEvents {
      key
      primaryText
    }
  }
`

export const getRecordTypes = gql`
  query GetRecordTypes {
    recordTypes {
      id
      name
    }
  }
`

export const getImageApid = gql`
  query ImageApid($imageArk: ID!) {
    imageApid(imageArk: $imageArk)
  }
`

export const getImageApidByName = gql`
  query ImageApidByName($imageName: String!) {
    imageApidByName(imageName: $imageName)
  }
`

export const getImageGroupId = gql`
  query ImageGroupId($imageApid: ID!) {
    getArtifactParent(ark: $imageApid)
  }
`
